import { render, staticRenderFns } from "./OrgApplication.vue?vue&type=template&id=08e85bf3&"
import script from "./OrgApplication.vue?vue&type=script&lang=js&"
export * from "./OrgApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports